// Calibres para el registro del campo de tiro — misma lista en la página
// pública de reservas y en los flujos del admin (crear reservación, recurrentes).
export const CALIBER_OPTIONS = ['22 LR', '380 ACP', '9MM', '38 SPL', '40 S&W', '45 ACP', '5.56 / 223', '7.62x39', '308 WIN', 'Escopeta 12GA'];
